export const POSITION_INCIDENT_SELECTOR_PATH_PATTERN = /\/ui\/login\/position-incident-selector/;
export const ADDITIONAL_INFO_PATH_PATTERN = /\/ui\/login\/additional-info/;

/**
 * True for the SPA pages that sit between a successful IDP challenge and a fully-established
 * WebEOC session (position/incident not committed yet). `/api/controlpanel/v1/session` legitimately
 * 401s on these pages, so callers deciding whether to bounce an unauthenticated visitor to the IDP
 * must exclude them - otherwise an IDP-authenticated user stuck here gets sent back to `/login/login/`,
 * which round-trips through `/login/callback/` and back to the same page, looping forever.
 */
export function isLoginFlowSpaPath(pathname: string): boolean {
    return POSITION_INCIDENT_SELECTOR_PATH_PATTERN.test(pathname) || ADDITIONAL_INFO_PATH_PATTERN.test(pathname);
}
